import classes from "./filters.module.scss";
import Label from "@/components-library/widgets/label";
import Flex from "@/components-library/layout/flex";
import Grid from "@/components-library/layout/grid";
import SelectableList from "@/components-library/widgets/selectable-list";
import classNames from "classnames";
import * as annoucementSlice from "../build-your-solution.slice";
const SECTOR = "Sector";
const BENEFICIARY = "Beneficiary";
const OUTGOINGS = "Outgoings";
const STATUS = "Status";

function Filters({
  beneficiaries,
  selectedBeneficiary,
  onBeneficiarySelect,
  outgoings,
  selectedOutgoing,
  onOutgoingSelect,
  sectors,
  selectedSector,
  onSectorSelect,
  statuses,
  selectedStatuses,
  onStatusSelect,
  isEnabled,
  onCancelFilterClick,
  onOrderAscClick,
  onOrderDescClick,
  nElements,
  sort,
  listRef,
  isSectorFilterOpen,
  isBeneficiaryFilterOpen,
  isOutgoingsFilterOpen,
  isStatusFilterOpen,
  onHeaderClick,
  isFilterSectorUsed,
  isFilterBeneficiaryUsed,
  isFilterOutgoingsUsed,
  isFilterStatusUsed,
}) {
  const isMobile = typeof window !== "undefined" && window.innerWidth <= 768;

  return (
    <Flex
      align="flex-start"
      direction="column"
      justify="flex-start"
      className={classNames(classes.container, {
        [classes.disabled]: !isEnabled,
      })}
    >
      <Label
        tag="h3"
        weight="bold"
        align="center"
        color="primary"
        className={classes.title}
      >
        Filtra i bandi
      </Label>

      <Grid columns={isMobile ? "1fr" : "1fr 1fr 1fr"}>
        <SelectableList
          title="Settore"
          list={sectors}
          value={selectedSector}
          onItemSelect={onSectorSelect}
          onHeaderClick={() => onHeaderClick(SECTOR)}
          isOpen={isSectorFilterOpen}
          isEnabled={isEnabled}
          isMultiSelect={true}
          className={classes.list}
          headerClassName={classNames(classes.headerList, {
            [classes.valid]: isFilterSectorUsed,
          })}
          titleClassName={classes.titleList}
        />

        <SelectableList
          title="Beneficiari"
          list={beneficiaries}
          value={selectedBeneficiary}
          onItemSelect={onBeneficiarySelect}
          onHeaderClick={() => onHeaderClick(BENEFICIARY)}
          isOpen={isBeneficiaryFilterOpen}
          isEnabled={isEnabled}
          isMultiSelect={true}
          className={classes.list}
          headerClassName={classNames(classes.headerList, {
            [classes.valid]: isFilterBeneficiaryUsed,
          })}
          titleClassName={classes.titleList}
        />

        <SelectableList
          title="Spese finanziate"
          list={outgoings}
          value={selectedOutgoing}
          onItemSelect={onOutgoingSelect}
          onHeaderClick={() => onHeaderClick(OUTGOINGS)}
          isOpen={isOutgoingsFilterOpen}
          isEnabled={isEnabled}
          isMultiSelect={true}
          className={classes.list}
          headerClassName={classNames(classes.headerList, {
            [classes.valid]: isFilterOutgoingsUsed,
          })}
          titleClassName={classes.titleList}
        />
      </Grid>

      {!isMobile && <div className={classes.secondRow} />}

      <Grid columns={isMobile ? "1fr" : "1fr 1fr 1fr"}>
        <SelectableList
          title="Status"
          list={statuses}
          value={selectedStatuses}
          onItemSelect={onStatusSelect}
          onHeaderClick={() => onHeaderClick(STATUS)}
          isOpen={isStatusFilterOpen}
          isEnabled={isEnabled}
          isMultiSelect={true}
          className={classes.list}
          headerClassName={classNames(classes.headerList, {
            [classes.valid]: isFilterStatusUsed,
          })}
          titleClassName={classes.titleList}
        />
      </Grid>

      <div className={classes.spacer} />
      <div className={classes.line} />
      <Grid columns={isMobile ? "1fr" : "1fr 1fr 1fr"} rowGap={"1rem"}>
        <Flex
          align="center"
          direction="row"
          justify={isMobile ? "center" : "flex-start"}
          style={{ height: "fit-content" }}
        >
          <img
            src={"/images/icons/icon-close.svg"}
            alt="close"
            onClick={onCancelFilterClick}
            className={classes.iconCancel}
          />
          <Label color="secondary" align={isMobile ? "center" : "start"}>
            Cancella filtri
          </Label>
        </Flex>
        <Flex
          align="center"
          direction="row"
          justify="center"
          style={{ height: "fit-content" }}
        >
          <Label color="secondary" align="start">
            Elementi visualizzati
          </Label>
          <Label
            color="secondary"
            align="start"
            weight="bold"
            style={{ marginLeft: "0.5rem" }}
          >
            {nElements}
          </Label>
        </Flex>
        <Flex
          align="center"
          direction="row"
          justify={isMobile ? "center" : "flex-end"}
          style={{ height: "fit-content" }}
        >
          <Label color="secondary" align="start">
            Ordina elementi
          </Label>
          <img
            src={
              sort === annoucementSlice.SORT.ASC
                ? "/images/icons/icon-arrow-up-active.svg"
                : "/images/icons/icon-arrow-up.svg"
            }
            alt="close"
            onClick={onOrderAscClick}
            style={{ marginLeft: "0.5rem", cursor: "pointer" }}
          />
          <img
            src={
              sort === annoucementSlice.SORT.DESC
                ? "/images/icons/icon-arrow-down-active.svg"
                : "/images/icons/icon-arrow-down.svg"
            }
            alt="close"
            onClick={onOrderDescClick}
            style={{ marginLeft: "0.5rem", cursor: "pointer" }}
          />
        </Flex>
      </Grid>
      <div className={classes.line} ref={listRef} />
    </Flex>
  );
}

export default Filters;
